export default "__VITE_ASSET__Bd1XA4JY__"